import {DeliverableId} from './deliverable';

export interface HeldPositionIdentifier {
    accountId: number;
    deliverableId: DeliverableId;
    positionId: string; // "none"
}

export enum HeldPositionReason {
    deposit = 'deposit'
}

export interface HeldPosition {
    balance: string; // "1808400000000000"
    committedBalance: string; // "0"
    currentValue: string; // "1962114000"
    entryValue: string; // "1808400000000000"
    fees: string; // "0"
    identifier: HeldPositionIdentifier;
    portfolioValue: string; // "1962114000"
    profitOrLoss: string; // "-208631"
    reason: HeldPositionReason;
    referenceRate: string; // "108500000"
    timestamp: string; // "1759149240101133800"
    valueAtRisk: string; // "0"
    valueDeliverableId: DeliverableId;
    yield: string;
}

export const getHeldPositionKey = (posIdentifier: HeldPositionIdentifier): string =>
    [
        posIdentifier.positionId,
        posIdentifier.accountId,
        posIdentifier.deliverableId
    ].join(':');

export const clearHeldPositionIdentifier = (
    {
        positionId,
        accountId,
        deliverableId
    }: HeldPositionIdentifier
): HeldPositionIdentifier => ({
    positionId,
    accountId,
    deliverableId
});
